<template>
	<div class="global-footer footer-header">
		<p
			v-for="(item, $index) in items.footerLinks"
			:key="$index"
			:class="{ active: userSelected === item.group_name }"
		>
			<a
				href="javascript:void(0)"
				@click="(e) => { e.preventDefault(); disSublinks(item, $index + 1); }"
				@mouseover="disSublinks(item, $index + 1)"
			>
				{{ item.group_name }}
			</a>
		</p>
	</div>
</template>
<script>
export default {
	name: 'FooterHeaders',
	props: {
		items: {
			type: Object,
			required: true,
		},
		userSelected: {
			type: String,
			required: true,
		},
		disSublinks: {
			type: Function,
			required: true,
		},
		// eslint-disable-next-line vue/require-default-prop
		data: {
			type: Object,
		},
	},
};
</script>
